import axios from 'axios'
import { Message } from 'element-ui'
import { API_BASE_URI } from '@/config'

// 创建axios实例
const service = axios.create({
  baseURL: API_BASE_URI // api的base_url
  // timeout: 10000                  // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

const SUCC = 0
const ERR_MSG_DURATION = 3000

// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === SUCC) {
      return res
    } else {
      Message({
        message: res.msg,
        type: 'error',
        duration: ERR_MSG_DURATION
      })
      let error = 'error'
      return Promise.reject(error)
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/fetch.js